import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const buildDocDefinition = (template: unknown) => ({
  content: Array.isArray(template) ? template : [template],
  footer: function () {
    return {
      table: {
        widths: ["*", "*", "*"],
        body: [
          [
            {
              text: "2248 Broadway #1702\nNew York, NY 10024",
              fontSize: 8,

              border: [false, false, false, false],
            },
            {
              text: "Neta Foundation, Inc.\nEIN 93-2276661",
              fontSize: 8,
              border: [false, false, false, false],
            },
            {
              text: [
                "www.netafoundation.org ",

                {
                  text: "contact@netafoundation.org",
                  link: "mailto:contact@netafoundation.org",
                  color: "blue",
                  decoration: "underline",
                },
              ],
              fontSize: 8,
              border: [false, false, false, false],
            },
          ],
        ],
      },
      margin: [50, 0, 20, 10], // Adjust margins as needed
    };
  },
});

export const compileHtmlToPDF = (template: unknown) => {
  const docDefinition = buildDocDefinition(template);
  return pdfMake.createPdf(docDefinition).open();
};

export const getCompiledPdfUrl = (template: unknown) => {
  const docDefinition = buildDocDefinition(template);
  return new Promise<string>((resolve) => {
    pdfMake.createPdf(docDefinition).getBlob((blob: Blob) => {
      resolve(URL.createObjectURL(blob));
    });
  });
};
